
  export default {
    data () { return { flags: { 'ga': '🇮🇪', en: '🏴󠁧󠁢󠁥󠁮󠁧󠁿', pl: '🇵🇱' } }; },
    computed: {
      availableLocales () {
        return this.$i18n.locales.filter(i => i.code !== this.$i18n.locale);
      },
      contrastMode () {
        return this.$nuxt.$colorMode.preference;
      },
      enabled () {
        return process.env.NUXT_ACCESSIBILITY_MENU_ENABLED;
      }
    },
    methods: {
      toggleContrastMode () {
        this.$nuxt.$colorMode.preference = ((this.contrastMode === 'contrast') ? 'system' : 'contrast');
      }
    }
  };
